
define('app/board/models/timerModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var TimerModel = Backbone.Model.extend({	
		defaults: {
			id: null, 
			isActive: null,
			auctionTeamId: null,
			auctionValue: null,
			endTime: null,
			duration: null,
			pauseTimeRemaining: null,
			serverTimeDiff: null,
	    },

	    initialize: function() {
	    	
	    },
	});
	
	return TimerModel;  
});